import React from "react";
import { compose } from "recompose";
import * as validate from "app/validate";
import * as forms from "app/forms";
import { injectIntl } from "react-intl";

const enhance = compose(
  forms.reduxField,
  forms.interactive,
  forms.unlabelled,
  injectIntl
);
const InputField = enhance(forms.CustomInputGroup);
const TextArea = enhance(forms.CustomTextArea);

export const TitleField = injectIntl(props => {
  const { intl, ...rest } = props;
  return (
    <InputField
      type="text"
      label={intl.formatMessage({
        id: "proposal.title",
        defaultMessage: "Title"
      })}
      validate={[validate.required]}
      {...rest}
      name="title"
    />
  );
});

export const DescriptionField = injectIntl(props => {
  const { intl, ...rest } = props;
  return (
    <TextArea
      type="text"
      label={intl.formatMessage({
        id: "proposal.description",
        defaultMessage: "Description"
      })}
      {...rest}
      name="description"
    />
  );
});

export const ShortDescriptionField = injectIntl(props => {
  const { intl, ...rest } = props;
  return (
    <TextArea
      type="text"
      label={intl.formatMessage({
        id: "proposal.shortdescription",
        defaultMessage: "Short description"
      })}
      {...rest}
      name="shortDescription"
    />
  );
});

export { ObjectsField } from "./ObjectsField";



// WEBPACK FOOTER //
// ./src/app/proposals/fields/index.js